import axios from 'axios';

import { SET_Wiki_Create_Config } from './types';

export function setWikiCreateConfig(config) {
  return {
    type: SET_Wiki_Create_Config,
    config,
  };
}

export function getWikiCreateCongig(wId) {
  return (dispatch) => {
    // return axios.get("/bot/api/" + wId + "/wiki/aliases?channel="+channel)
    return axios.get('/bot/api/w/' + wId + '/wiki/createConfig').then((res) => {
      if (res && res.data && res.data.success) {
        dispatch(setWikiCreateConfig(res.data.wikiConfig));
      }
      return res;
    });
  };
}
export function editWikiCreateCongig(wId, data) {
  return (dispatch) => {
    // return axios.put("/bot/api/" + wId + "/wiki/"+aId+"/alias",data)
    return axios
      .post('/bot/api/w/' + wId + '/wiki/createConfig', data)
      .then((res) => {
        if (res && res.data && res.data.success) {
          dispatch(setWikiCreateConfig(res.data.wikiConfig));
        }
        return res;
      });
  };
}

export function removeWikiCreateCongig(wId, aId) {
  return (dispatch) => {
    // return axios.delete("/bot/api/" + wId + "/wiki/"+aId+"/alias")
    return axios
      .delete('/bot/api/w/' + wId + '/wiki/' + aId + '/alias')
      .then((res) => {
        // console.log("res====>")
        if (res.data.success) {
          dispatch(setWikiCreateConfig({}));
        }
        return res;
      });
  };
}

export const getActivity = ({
  wId,
  page,
  search_text,
  search_range,
  search_feedback_type,
  search_match_type,
  search_channel,
}) => {
  let url = `/bot/api/w/${wId}/wiki/activity?`;
  url += `&page=${page || 1}`;

  if (search_text) url += `&search_text=${search_text}`;
  if (search_range && search_range !== '30days')
    url += `&search_range=${search_range}`;
  if (search_feedback_type && search_feedback_type !== 'all')
    url += `&search_feedback_type=${search_feedback_type}`;
  if (search_match_type && search_match_type !== 'both')
    url += `&search_match_type=${search_match_type}`;
  if (
    search_channel &&
    search_channel.key &&
    search_channel.key !== 'all_channels'
  )
    url += `&search_channel=${search_channel.key}`;

  return axios.get(url).then((res) => {
    return res;
  });
};

export const getUserKeyWordFilter = ({ wId, user_id }) => {
  return axios
    .get(`/bot/api/w/${wId}/wiki/userKeywordFilter/${user_id}`)
    .then((res) => res);
};
export const updateUserKeyWordFilter = ({ wId, user_id, data }) => {
  return axios
    .post(`/bot/api/w/${wId}/wiki/userKeywordFilter/${user_id}`, data)
    .then((res) => res);
};

export const getTopKeywords = ({ wId, search_channel, search_range }) => {
  let link = `/bot/api/w/${wId}/wiki/getTopKeywords?`;

  if (search_range && search_range !== '30days')
    link += `&search_range=${search_range}`;
  if (
    search_channel &&
    search_channel.key &&
    search_channel.key !== 'all_channels'
  )
    link += `&search_channel=${search_channel.key}`;

  return axios.get(link).then((res) => {
    return res;
  });
};
